import { useLocalStorage } from '@/hooks/useLocalStorage.hook';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

export const useUsername = () => {
  const { value, setItem, removeItem } = useLocalStorage<string>(
    StorageKeysEnum.username
  );

  return {
    username: value,
    setUsername: setItem,
    removeItem: removeItem,
  };
};
